module.exports = __webpack_public_path__ + "media/images/partner_logo_2-bd1fe70c6abf750da48d41eb3d39f45f.png";